import { Rpc } from '../rpc';
import { RpcObservableServer } from '../rpc-observable-server';
import {
    RpcObservableCopilotError, RpcObservableCopilotKey, RpcObservableCopilotRequest, RpcObservableCopilotResult
} from './rpc-observable-copilot-model';

/**
 * Iframe to Shell pair, the receiving/Shell port.
 */
export class RpcObservableCopilotServer
    extends RpcObservableServer<RpcObservableCopilotRequest, RpcObservableCopilotResult, RpcObservableCopilotError> {

    /**
     * Initializes a new instance of the RpcObservableCopilotServer class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservableCopilotKey.command, RpcObservableCopilotKey.version);
    }
}
